import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginPathFor } from '@/shared/utils/loginRedirect';
import { useAuthStore } from '@/store/authStore';

/** Wraps an action on a public page (add to cart, buy now): a visitor is sent
 *  to the login page and returns to this screen after signing in; a signed-in
 *  user runs the action. */
const useRequireLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLogin = useAuthStore((state) => state.isLogin);

  return useCallback(
    (action: () => void) => {
      if (!isLogin) {
        navigate(loginPathFor(location));
        return;
      }
      action();
    },
    [isLogin, location, navigate]
  );
};

export default useRequireLogin;
